import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import { Customer } from "@/types/customer-type";
import { OrderResponse } from "@/types/order-type";
import { TProductWithRelation } from "@/types/product-type";
import type { PosCartItem } from "@/pages/pos/hooks/use-pos-cart";

export interface CreatePosOrderRequest {
  customerId?: string;
  customerName?: string;
  customerPhone?: string;
  customerAddress?: string;
  source?: string;
  telegramId?: string;
  telegramUsername?: string;
  items: { variantId: string; quantity: number }[];
}

export async function getPosProducts(): Promise<
  ApiResponse<TProductWithRelation[]>
> {
  return apiClient.get<TProductWithRelation[], object>("/pos/products");
}

export async function getPosCustomerByTelegram(
  telegramId: string
): Promise<ApiResponse<Customer>> {
  return apiClient.get<Customer, void>(
    `/pos/customers/by-telegram/${encodeURIComponent(telegramId)}`
  );
}

export async function createPosOrder(
  items: PosCartItem[],
  customerName: string,
  customerPhone: string,
  customerId?: string,
  customerAddress?: string,
  extra?: {
    source?: string;
    telegramId?: string | null;
    telegramUsername?: string | null;
  }
): Promise<ApiResponse<OrderResponse>> {
  const request: CreatePosOrderRequest = {
    customerId: customerId || undefined,
    customerName,
    customerPhone,
    customerAddress: customerAddress?.trim() || undefined,
    source: extra?.source || "telegram",
    telegramId: extra?.telegramId || undefined,
    telegramUsername: extra?.telegramUsername || undefined,
    items: items.map((item) => ({
      variantId: item.variantId,
      quantity: item.quantity,
    })),
  };

  return apiClient.post<OrderResponse, CreatePosOrderRequest>(
    "/pos/orders",
    request
  );
}
